import React from 'react'
import { AlertBox, CustomerServiceTelephone } from '@mobi/component-library/Common/V2'
import { font, spacing } from '@mobi/component-library/Theme/Common'

interface SignupErrorProps {
  isOpen: boolean
  applicationId?: string
  onClose: () => void
}

export const SignupError: React.FC<SignupErrorProps> = ({ isOpen, applicationId, onClose }) => {
  return (
    <AlertBox
      isOpen={isOpen}
      title='Sorry, an error occurred!'
      text={
        <div>
          There was an error in creating your account. Please contact us on{' '}
          <CustomerServiceTelephone />{' '}
          {!!applicationId && 'and provide the following Application ID '}
          so we can assist you in completing your registration.
          {!!applicationId && (
            <div style={{ marginTop: spacing.md, fontWeight: font.weight.medium }}>
              Application ID: {applicationId}
            </div>
          )}
        </div>
      }
      confirmText='Close'
      onConfirm={onClose}
      actionOrientation='vertical'
      alignLeft
    />
  )
}

export default SignupError
